
<template> 
  <!-- <article v-bind:class="eventData?.isFav ? 'fav-active' : ''" class="info-box bg-white p-2 global-a-box" v-if="!isOrganizer" @click="detail(`${eventData?.title}`,eventData?._id)">                               
      <span class="info-box-img position-relative overflow-hidden">
          <img :src="`${eventImg(eventData?.media ? eventData?.media[0] : '')}`"  :alt="eventData?.title">
          <a href="javascript:;" @click="handleFavIconClick"  v-if="showFavIcon" class="text-white pt-2 pb-2 ps-3 pe-3 d-inline-flex heart-icon">
            <i class="fa fa-heart" aria-hidden="true"></i>
          </a>
          <a href="javascript:;" class="primary-bg text-white pt-2 pb-2 ps-3 pe-3 d-inline-flex info-box-category">{{ eventData?.activeEventsLocation == '1' ? 'Online' : ((eventData?.activeEventsLocation == '2') ? 'In Person' : 'Both') }}</a>
      </span>
      
      <span class="info-box-content">
          <span class="info-box-title mb-3 mt-3 d-hex-color">
            {{ eventData?._doc?.title }}
          </span>
          <span class="info-box-time d-flex mb-1 mt-1">
              <span>
                  <img :src="carbonTime" alt="img" class="info-box-content-icon">
              </span>
              <span class="info-box-content-s" v-if="!eventData?.isOnline">
                <label class="text-heading__color">
                    {{ 
                      
                      dateModel.changeDateFormat(eventData?.startDateTime,eventData?.timezone)
                      
                    }}
                    
                    <label class="between-dash-small">-</label>

                    {{
                        dateModel.time_with_hour_only(eventData?.startDateTime, eventData?.timezone) 
                    }}

                    <label class="between-dash-lg">-</label>

                    {{ 
                      
                      dateModel.changeDateFormat(eventData?.endDateTime,eventData?.timezone)
                      
                    }}
                    
                    <label class="between-dash-small">-</label>

                    {{
                        dateModel.time_with_hour_only(eventData?.endDateTime, eventData?.timezone) 
                    }}

                    {{ 
                    
                      new Date(eventData?.endDateTime).toLocaleTimeString('en', {
                                                    timeZone: eventData?.timezone,
                                                    timeZoneName: 'short',
                                                  }).split(' ')[2]
                    }}
                  
                </label>
              </span>

              <span class="info-box-content-s" v-if="eventData?.isOnline">
                <label class="text-heading__color">
                      {{ 
                       
                        
                        dateModel.changeDateFormat(eventData?.startDateTime,userCurrentTimezone())
                        
                      }}
                      
                      <label class="between-dash-small">-</label>

                      {{
                          dateModel.time_with_hour_only(eventData?.startDateTime, userCurrentTimezone()) 
                      }}

                      <label class="between-dash-lg">-</label>

                      {{ 
                       
                        
                        dateModel.changeDateFormat(eventData?.endDateTime,userCurrentTimezone())
                        
                      }}
                      
                      <label class="between-dash-small">-</label>

                      {{
                          dateModel.time_with_hour_only(eventData?.endDateTime, userCurrentTimezone()) 
                      }}

                      {{ 
                      
                        new Date(eventData?.endDateTime).toLocaleTimeString('en', {
                                                      timeZone: userCurrentTimezone(),
                                                      timeZoneName: 'short',
                                                    }).split(' ')[2]
                      }}
                    
                </label>
              </span>
          </span>
          <span class="info-box-location d-flex mb-1 mt-1" v-if="showCreatorName">
              <span>
                  <img :src="tablerBuilding" alt="img" class="info-box-content-icon">
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile" v-if="eventData?.role == 'Organization' && eventData?.creator?.organization">
                {{ `${eventData?.creator?.organization}` }}                 
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile" v-else-if="eventData?.role == 'Organization' && eventData?.createdBy?.organization">
                {{ `${eventData?.createdBy?.organization}` }}                
              </span>


              <span class="info-box-content-s" @click="handleGoToPublicProfile" v-else-if="eventData?.role == 'Organization' && creatorData && !eventData?.createdBy?.organization && !eventData?.creator?.organization">
                {{ creatorData?.organization }}             
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile" v-else-if="eventData?.role == 'Organizer' && eventData?.createdBy?.organizerDetails?.firstName">
                {{ `${eventData?.createdBy?.organizerDetails?.firstName}` }} {{ `${eventData?.createdBy?.organizerDetails?.lastName}` }}          
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile" v-else-if="eventData?.role == 'Organizer' && creatorData">
                {{ creatorData?.organizerDetails?.firstName }} {{ `${creatorData?.organizerDetails?.lastName}` }}          
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile" v-else-if="eventData?.role == 'Organizer' && eventData?.creator">
                {{ eventData?.creator?.organizerDetails?.firstName }} {{ `${eventData?.creator?.organizerDetails?.lastName}` }}          
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile" v-else-if=" eventData?.createdBy && eventData?.createdBy?.role == 'Seeker'">
                {{ eventData?.createdBy?.organizerDetails?.firstName }} {{ `${eventData?.createdBy?.organizerDetails?.lastName}` }}          
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile" v-else-if=" eventData?.createdBy && eventData?.createdBy?.role == 'Organizer'">
                {{ eventData?.createdBy?.organization }}         
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile"  v-else-if="!eventData?.role && eventData?.creator?.organization">
                {{ `${eventData?.creator?.organization}` }}      
              </span>

              <span class="info-box-content-s" @click="handleGoToPublicProfile"  v-else-if="!eventData?.role && !eventData?.creator?.organization">
                {{ `${eventData?.createdBy?.organization}` }}   
              </span>
              <span class="info-box-content-s"  v-else>
                -  
              </span>

              
              
              
          </span>
          

          <span class="info-box-tag d-flex mb-1 mt-1" v-if="eventData?.tags?.length > 0"> 
                  <span>
                      <img :src="materialSymbolsTag" alt="img" class="info-box-content-icon">
                  </span>
                  <span class="info-box-content-s">
                     
                      <label v-for="(tag,index) in eventData?.tags" >
                        {{ index != 0 ? '&nbsp' : '' }} {{ tag }} {{ ( eventData?.tags.length != (Number(index) + 1)) ? ' - ' : '' }}
                      </label>
                  </span>
                  
          </span>

          

      </span>  

      <span class="info-box-content info-box-content-footer">
              <span>
              <hr>
              </span>

              <span v-if="!isEventTicketAvailable && !isEventTicketAvailableLoading" class="info-box-price d-flex justify-content-end">
                <span class="primary-color fw-semibold" >Sold Out</span>
              </span>
              
              <span v-if="!isEventTicketAvailableLoading && isEventTicketAvailable" class="info-box-price d-flex justify-content-end">
                  <span class="primary-color fw-semibold" v-if="((ticketpriceRange()?.start == 0 && !ticketpriceRange()?.end) )">Free</span>
                  <span class="primary-color fw-semibold" v-if="(ticketpriceRange()?.start >= 0 && ticketpriceRange()?.end > 0 )">
                    Price  {{
                      `$${ticketpriceRange()?.start}  ${ticketpriceRange()?.end ? '- $'+ticketpriceRange()?.end : ''} `
                    }}
                  </span>
                  <span class="primary-color fw-semibold" v-if="(ticketpriceRange()?.start > 0 && !ticketpriceRange()?.end )">
                    Price  {{
                      `$${ticketpriceRange()?.start}  `
                    }}
                  </span>

                  <span class="primary-color fw-semibold" v-if="!eventData?.minprice && (eventData?.createdBy?.role === ROLES.PLANNER || eventData?.creator?.role === ROLES.PLANNER || eventData?.role === ROLES.PLANNER)">
                    Starts at ${{ eventData?.price }}
                  </span>

                  <span class="primary-color fw-semibold" v-if="eventData?.minprice && (eventData?.creator?.role === ROLES.PLANNER || eventData?.createdBy?.role === ROLES.PLANNER || eventData?.role === ROLES.PLANNER)">
                    Starts at ${{ eventData?.minprice }}
                  </span>

                  
              </span>
      </span>                            
  </article> -->
  <!-- Update Organizer Later -->
  <!-- <div v-if="isOrganizer" class="cursor-pointer mb-3" :class="isLandscape ? `` : ``" >
    <div class="relative w-full ">
      
     
    </div>
    <div class="py-2.5 px-4  w-full min-h-[100px] relative d-flex justify-content-center flex-column"
      :class="isLandscape ? `h-auto bg-site__light__gray` : `bg-white shadow-primary__shadow`">
        <h5 style="width: 100%;" class="text-primary__color text-2xl font-semibold pb-2.5 lg__mobile:text-lg text-ellipsis overflow-hidden whitespace-nowrap"> {{ eventData?.organization }}</h5>
        
    
      <p class="text-icon__color text-sm pb-2.5 lg__mobile:text-xs ">
        <label class="text-heading__color">
          {{ eventData?.bio }}
             
          
            
          
        </label>
      </p>
      <p class="text-icon__color text-sm pb-2.5 lg__mobile:text-xs ">
        <label class="text-heading__color " >
         
          <router-link 
            :to="{ name: ROUTES.ORGANIZATION, params: { organizerId: eventData?._id ? eventData?._id : 0 } }"
            style="text-decoration: underline;cursor: pointer;">
            <strong>More Details</strong>
          </router-link>
           
          
        </label>
      </p>
      
    </div>
  </div> -->

  <!-- <article v-if="isOrganizer" class="organizer-article bg-white" @click="viewProfile(eventData?.role,eventData?._id)">
        <span class="d-flex">
            <span class="organizers-img">
                <img v-if="eventData?.role == 'Seeker'" :src="`${userImg('Seeker',eventData?.organizerDetails?.profilePicture?.url)}`" alt="img" >
                <img v-if="eventData?.role == 'Organizer'" :src="`${userImg('Organizer',eventData?.organizationDetails?.profilePicture?.url)}`" alt="img" >
            </span>
            <span class="organizers-con d-flex align-items-center">
                <span class="title" v-if="eventData?.role == 'Seeker'">{{ eventData?.organizerDetails?.firstName }} {{ eventData?.organizerDetails?.lastName }}</span>
                <span class="title" v-if="eventData?.role == 'Organizer'">{{ eventData?.organization }}</span>


                <span v-if="eventData?.role == 'Seeker'" class="d-flex sub-title"><span class="primary-color pe-1">{{ eventData?.bio }}</span> </span>
                <span v-if="eventData?.role == 'Organizer'" class="d-flex sub-title"><span class="primary-color pe-1">{{ eventData?.organizationDescription }}</span> </span>
            </span>
        </span>
  </article> -->

  <article v-bind:class="normalizedEventData?.isFav ? 'fav-active' : ''" 
           class="info-box bg-white p-2 global-a-box" 
           v-if="!isOrganizer" 
           @click="detail(`${normalizedEventData?.title}`, normalizedEventData?._id)">
    <span class="info-box-img position-relative overflow-hidden">
      <img :src="eventImg(normalizedEventData?.media?.[0] || '')" 
           :alt="normalizedEventData?.title">
      <a href="javascript:;" @click="handleFavIconClick" v-if="showFavIcon" 
         class="text-white pt-2 pb-2 ps-3 pe-3 d-inline-flex heart-icon">
        <i class="fa fa-heart" aria-hidden="true"></i>
      </a>
      <a href="javascript:;" class="primary-bg text-white pt-2 pb-2 ps-3 pe-3 d-inline-flex info-box-category">
        {{ normalizedEventData?.activeEventsLocation === '1' ? 'Online' : 
          (normalizedEventData?.activeEventsLocation === '2' ? 'In Person' : 'Both') }}
      </a>
    </span>

    <span class="info-box-content">
      <span class="info-box-title mb-3 mt-3 d-hex-color">
        {{ normalizedEventData?.title }}
      </span>

      <span class="info-box-time d-flex mb-1 mt-1">
        <span>
          <img :src="carbonTime" alt="img" class="info-box-content-icon">
        </span>
        <span class="info-box-content-s" v-if="!normalizedEventData?.isOnline">
          <label class="text-heading__color">
            {{ dateModel.changeDateFormat(normalizedEventData?.startDateTime, normalizedEventData?.timezone) }}
            <label class="between-dash-small">-</label>
            {{ dateModel.time_with_hour_only(normalizedEventData?.startDateTime, normalizedEventData?.timezone) }}
            <label class="between-dash-lg">-</label>
            {{ dateModel.changeDateFormat(normalizedEventData?.endDateTime, normalizedEventData?.timezone) }}
            <label class="between-dash-small">-</label>
            {{ dateModel.time_with_hour_only(normalizedEventData?.endDateTime, normalizedEventData?.timezone) }}
            {{ new Date(normalizedEventData?.endDateTime).toLocaleTimeString('en', {
              timeZone: normalizedEventData?.timezone,
              timeZoneName: 'short',
            }).split(' ')[2] }}
          </label>
        </span>

        <span class="info-box-content-s" v-if="normalizedEventData?.isOnline">
          <label class="text-heading__color">
            {{ dateModel.changeDateFormat(normalizedEventData?.startDateTime, userCurrentTimezone()) }}
            <label class="between-dash-small">-</label>
            {{ dateModel.time_with_hour_only(normalizedEventData?.startDateTime, userCurrentTimezone()) }}
            <label class="between-dash-lg">-</label>
            {{ dateModel.changeDateFormat(normalizedEventData?.endDateTime, userCurrentTimezone()) }}
            <label class="between-dash-small">-</label>
            {{ dateModel.time_with_hour_only(normalizedEventData?.endDateTime, userCurrentTimezone()) }}
            {{ new Date(normalizedEventData?.endDateTime).toLocaleTimeString('en', {
              timeZone: userCurrentTimezone(),
              timeZoneName: 'short',
            }).split(' ')[2] }}
          </label>
        </span>
      </span>

     <span class="info-box-location d-flex mb-1 mt-1" v-if="showCreatorName">
        <span>
          <img :src="tablerBuilding" alt="img" class="info-box-content-icon">
        </span>

        <span class="info-box-content-s" @click="handleGoToPublicProfile">

          <template v-if="normalizedEventData?.role">

            <!-- Organization -->
            <template v-if="normalizedEventData.role === 'Organization'">
              {{ 
                normalizedEventData.createdBy?.organization 
                || normalizedEventData.creator?.organization 
                || creatorData?.organization 
                || '-' 
              }}
            </template>

            <!-- Organizer -->
            <template v-else-if="normalizedEventData.role === 'Organizer'">
              {{
                normalizedEventData.createdBy?.organizerDetails?.firstName 
                || normalizedEventData.creator?.organizerDetails?.firstName 
                || normalizedEventData.createdBy?.firstName
                || normalizedEventData.creator?.firstName
                || creatorData?.organizerDetails?.firstName
                || creatorData?.firstName
                || '-'
              }}
              {{
                normalizedEventData.createdBy?.organizerDetails?.lastName 
                || normalizedEventData.creator?.organizerDetails?.lastName 
                || normalizedEventData.createdBy?.lastName
                || normalizedEventData.creator?.lastName
                || creatorData?.organizerDetails?.lastName
                || creatorData?.lastName
                || ''
              }}
            </template>

            <!-- Seeker -->
            <template v-else-if="normalizedEventData.role === 'Seeker'">
              {{
                normalizedEventData.createdBy?.organizerDetails?.firstName 
                || normalizedEventData.creator?.organizerDetails?.firstName
                || normalizedEventData.createdBy?.firstName
                || normalizedEventData.creator?.firstName
                || creatorData?.organizerDetails?.firstName
                || creatorData?.firstName
                || '-'
              }}
              {{
                normalizedEventData.createdBy?.organizerDetails?.lastName 
                || normalizedEventData.creator?.organizerDetails?.lastName
                || normalizedEventData.createdBy?.lastName
                || normalizedEventData.creator?.lastName
                || creatorData?.organizerDetails?.lastName
                || creatorData?.lastName
                || ''
              }}
            </template>

            <!-- Other roles fallback -->
            <template v-else>
              {{
                normalizedEventData.createdBy?.organization 
                || normalizedEventData.createdBy?.firstName
                || normalizedEventData.creator?.organization
                || normalizedEventData.creator?.firstName
                || creatorData?.organization
                || creatorData?.firstName
                || '-'
              }}
            </template>

          </template>

          <!-- If role missing -->
          <template v-else>
            {{
              normalizedEventData.createdBy?.organization 
              || normalizedEventData.createdBy?.firstName
              || normalizedEventData.creator?.organization
              || normalizedEventData.creator?.firstName
              || creatorData?.organization
              || creatorData?.firstName
              || '-'
            }}
          </template>

        </span>
     </span>

      <span class="info-box-tag d-flex mb-1 mt-1" v-if="normalizedEventData?.tags?.length > 0"> 
        <span>
          <img :src="materialSymbolsTag" alt="img" class="info-box-content-icon">
        </span>
        <span class="info-box-content-s">
          <label v-for="(tag,index) in normalizedEventData.tags" :key="index">
            {{ index != 0 ? '&nbsp' : '' }} {{ tag }} 
            {{ ( normalizedEventData.tags.length != (Number(index) + 1)) ? ' - ' : '' }}
          </label>
        </span>
      </span>
    </span>

    <span class="info-box-content info-box-content-footer">
      <span><hr></span>
      <!-- Not for an event AI Discovery found: Culture City sells no tickets
           for it, so an empty ticket list is not "Sold Out". -->
      <span v-if="!isEventTicketAvailable && !isEventTicketAvailableLoading && !hasExternalTickets" 
            class="info-box-price d-flex justify-content-end">
        <span class="primary-color fw-semibold">Sold Out</span>
      </span>
      
      <!-- in this span just add justify-content-between if there is share/copy button -->
      <span v-if="!isEventTicketAvailableLoading && isEventTicketAvailable" 
        class="info-box-price d-flex justify-content-between align-items-center"
      >
        <!-- copy button -->
        <!-- <span class="d-flex align-items-center gap-2">
          <span class="d-flex align-items-center gap-1">
            <button 
              type="button" 
              class="btn primary-bg copy-btn-hover" 
              style="white-space: nowrap !important;" 
              @click="copyUrlToClipboard($event, normalizedEventData?.title)"
            >
              Copy
            </button>
            <span id="sucessMessage" v-if="successMessage" class="toast-success">
              {{ successMessage }}
            </span>
          </span>
        </span> -->

     <span class="d-flex align-items-center gap-2">
        <button 
          type="button" 
          class="btn primary-bg copy-btn-hover" 
          style="white-space: nowrap !important;" 
          @click.stop.prevent="toggleShareOptions"
        >
          Share
        </button>

        <!-- Popup Modal -->
        <div 
          v-if="showShareOptions" 
          class="share-popup-overlay" 
          @click.self="closeSharePopup"
        >
          <div class="share-popup" @click.stop>
            <div class="popup-header">
              <button class="close-btn" @click="(e)=>closeSharePopup(e)">✖</button>
            </div>

            <!-- Copy URL Section -->
            <p class="popup-section-title">Copy URL</p>
            <div class="d-flex align-items-center gap-2 copy-input">
              <input 
                type="text" 
                class="form-control me-2"  
                :value="eventFullUrl(createSeoFriendlyUrl(normalizedEventData?.title))" 
                readonly 
                @click.stop
              >
              <button 
                type="button" 
                class="btn primary-bg copy-btn-hover" 
                @click="copyUrlToClipboard($event, normalizedEventData?.title)"
              >
                <font-awesome-icon :icon="faCopy" />
              </button>
              <span id="sucessMessage" v-if="successMessage" class="toast-success">
                {{ successMessage }}
              </span>
            </div>

            <!-- Share Event Section -->
            <p class="popup-section-title">Share Event</p>
            <div class="popup-icons">
              <a href="javascript:;" @click="(e)=>shareOnFacebook(e,eventDetails.title, eventDetails.startDateTime, eventDetails.timezone)">
                <img :src="facebookSvg" alt="Facebook" />
              </a>
              <a href="javascript:;" @click="(e)=>shareOnTwitter(e,eventDetails.title, eventDetails.startDateTime, eventDetails.timezone)">
                <img :src="twitterSvg" alt="Twitter" />
              </a>
              <a href="javascript:;" @click="(e)=>shareOnLinkedIn(e,eventDetails.title, eventDetails.startDateTime, eventDetails.timezone)">
                <img :src="linkedinSvg" alt="LinkedIn" />
              </a>
              <a href="javascript:;" @click="(e)=>shareOnWhatsApp(e,eventDetails.title, eventDetails.startDateTime, eventDetails.timezone)">
                <img :src="whatsappSvg" alt="WhatsApp" />
              </a>
            </div>
          </div>
        </div>
     </span>

        <span class="primary-color fw-semibold" 
              v-if="((ticketpriceRange()?.start == 0 && !ticketpriceRange()?.end))">Free</span>
        <span class="primary-color fw-semibold" 
              v-if="(ticketpriceRange()?.start >= 0 && ticketpriceRange()?.end > 0)">
          Price {{ `$${ticketpriceRange().start}  ${ticketpriceRange().end ? '- $'+ticketpriceRange().end : ''} ` }}
        </span>
        <span class="primary-color fw-semibold" 
              v-if="(ticketpriceRange()?.start > 0 && !ticketpriceRange()?.end)">
          Price {{ `$${ticketpriceRange().start}  ` }}
        </span>
        <span class="primary-color fw-semibold" 
              v-if="!normalizedEventData?.minprice && (normalizedEventData?.createdBy?.role === ROLES.PLANNER || normalizedEventData?.creator?.role === ROLES.PLANNER || normalizedEventData?.role === ROLES.PLANNER)">
          Starts at ${{ normalizedEventData.price }}
        </span>
        <span class="primary-color fw-semibold" 
              v-if="normalizedEventData?.minprice && (normalizedEventData?.creator?.role === ROLES.PLANNER || normalizedEventData?.createdBy?.role === ROLES.PLANNER || normalizedEventData?.role === ROLES.PLANNER)">
          Starts at ${{ normalizedEventData.minprice }}
        </span>
      </span>
    </span>
  </article>
  <article v-if="isOrganizer" class="organizer-article bg-white" 
           @click="viewProfile(normalizedEventData?.role, normalizedEventData?._id)">
    <span class="d-flex">
      <span class="organizers-img">
        <img v-if="normalizedEventData?.role == 'Seeker'" 
             :src="userImg('Seeker', normalizedEventData?.organizerDetails?.profilePicture?.url)" 
             alt="img">
        <img v-if="normalizedEventData?.role == 'Organizer'" 
             :src="userImg('Organizer', normalizedEventData?.organizationDetails?.profilePicture?.url)" 
             alt="img">
      </span>
      <span class="organizers-con d-flex align-items-center">
        <span class="title" v-if="normalizedEventData?.role == 'Seeker'">
          {{ normalizedEventData?.organizerDetails?.firstName }} 
          {{ normalizedEventData?.organizerDetails?.lastName }}
        </span>
        <span class="title" v-if="normalizedEventData?.role == 'Organizer'">
          {{ normalizedEventData?.organization }}
        </span>
        <span v-if="normalizedEventData?.role == 'Seeker'" class="d-flex sub-title">
          <span class="primary-color pe-1">{{ normalizedEventData?.bio }}</span>
        </span>
        <span v-if="normalizedEventData?.role == 'Organizer'" class="d-flex sub-title">
          <span class="primary-color pe-1">{{ normalizedEventData?.organizationDescription }}</span>
        </span>
      </span>
    </span>
  </article>

  
</template>

<script setup>
import {watch,watchEffect ,ref} from "vue";
import { MEDIA_BASEURL, getEventImageUrl } from "@/utils/constants";
import { userCurrentTimezone } from "@/utils/helpers";
import { ROUTES } from "@/utils/constants/routes";
import { useRouter } from "vue-router";
import { ROLES } from "@/utils/constants";
import dateModel from "@/models/date.model";
import { createSeoFriendlyUrl } from "@/utils/helpers";
import carbonTime from "@/assets/g-img/carbon_time.svg";
import tablerBuilding from "@/assets/g-img/tabler_building.svg";
import materialSymbolsTag from "@/assets/g-img/material-symbols_tag.svg";
import ApiClient from "@/methods/apiclient";
import { computed } from "vue";
import { BASE_URL } from "@/utils/constants";
import { reactive } from "vue"; 
import { faCopy } from '@fortawesome/free-regular-svg-icons'

import facebookSvg from "@/assets/facebook-1.svg";
import twitterSvg from "@/assets/twitter-1.svg";
import linkedinSvg from "@/assets/linkedin-1.svg";
import whatsappSvg from "@/assets/whatsapp.svg";

const errorMessage = ref('');
const successMessage = ref('');

const eventDetails = reactive({
  title: '',
  startDateTime: '',
  timezone: ''
});

const router = useRouter()

const props = defineProps({
  eventData: {
    type: Object,
    required: true,
  },
  creatorData: {
    type: Object,
  },
  showFavIcon:Boolean,
  isEdit: Boolean,
  backButton: Boolean,
  isLandscape: Boolean,
  isOrganizer:{
    type:Boolean,
    default:false
  },
  showCreatorName:{
    type:Boolean,
    default:true
  }
})

const isEventTicketAvailable = ref(false);
const isEventTicketAvailableLoading = ref(true);
const hasExternalTickets = ref(false);

const normalizedEventData = computed(() => props.eventData?._doc || props.eventData)

watchEffect(() => {
  if (props.isOrganizer === false && normalizedEventData.value && Object.keys(normalizedEventData.value).length > 0) {
    const eventPageslug = normalizedEventData.value.pageSlug;
    ApiClient.get('event/remaining-tickets', { eventId: eventPageslug }).then(res => {
      // An event AI Discovery found: Culture City sells no tickets for it, so
      // an empty ticket list is not "Sold Out" (see getRemainingTickets).
      hasExternalTickets.value = !!res?.externalTickets;
      if (res.data) {
        res.data.forEach(element => {
          if (element.ticketsRemaining > 0) {
            isEventTicketAvailable.value = true;
          }
        });
      }
      isEventTicketAvailableLoading.value = false;
    });
  }
});

watch(() => normalizedEventData.value, (newValue) => {
  if (newValue) {
    eventDetails.title = newValue.title;
    eventDetails.startDateTime = newValue.startDateTime;
    eventDetails.timezone = newValue.timezone;
  }
}, { immediate: true });

// toogle the share icons logic
const showShareOptions = ref(false);
const toggleShareOptions = () => {
  showShareOptions.value = !showShareOptions.value;
};

// for closing the pop-up
const closeSharePopup = (event) => {
  event.stopPropagation();
  showShareOptions.value = false
}

// Fixed ticket price range calculation
const ticketpriceRange = () => {
  let value = {};
  const tickets = normalizedEventData.value?.tickets?.categories;
  if (tickets?.length) {
    let arr = tickets.map(itm => itm.price).sort((a, b) => a - b);
    value.start = arr[0];
    if (arr.length > 1) value.end = arr[arr.length - 1];
  }
  return value;
};

// Fixed favorite handler
const handleFavIconClick = (event) => {
  event.stopPropagation();
  emit('handle-fav-click', {
    _id: normalizedEventData.value._id,
    isFav: normalizedEventData.value.isFav
  });
};

// const  handleGoToPublicProfile = (event) => {
//   event.stopPropagation();
//   const data = normalizedEventData.value;
//   if(data.role == 'Organization' && data.creator && data.creator.organization){

//     router.push({name:ROUTES.ORGANIZER_PUBLIC_PROFILE,params:{organizerId:  data.creator._id, profileType:'business'}}).then(() => {
//       location.href = window.location.href; // Force reload by updating the URL
//     });

//   }else if(data.role == 'Organization' && data.createdBy.organization){

//     router.push({name:ROUTES.ORGANIZER_PUBLIC_PROFILE,params:{organizerId:  data.createdBy._id, profileType:'business'}}).then(() => {
//       location.href = window.location.href; // Force reload by updating the URL
//     });

//   }else if(data.role == 'Organization' && props.creatorData && !data.createdBy.organization && !data.creator.organization){

//     router.push({name:ROUTES.ORGANIZER_PUBLIC_PROFILE,params:{organizerId:  props.creatorData._id, profileType:'business'}}).then(() => {
//       location.href = window.location.href; // Force reload by updating the URL
//     });

//   }else if(data.role == 'Organizer' && data.createdBy.organizerDetails.firstName){

//     router.push({name:ROUTES.ORGANIZER_PUBLIC_PROFILE,params:{organizerId:  data.createdBy._id, profileType:'personal'}}).then(() => {
//       location.href = window.location.href; // Force reload by updating the URL
//     });

//   }else if(data.role == 'Organizer' && props.creatorData){

//     router.push({name:ROUTES.ORGANIZER_PUBLIC_PROFILE,params:{organizerId:  props.creatorData._id, profileType:'personal'}}).then(() => {
//       location.href = window.location.href; // Force reload by updating the URL
//     });

//   }else if(data.role == 'Organizer' && data.creator){

//     router.push({name:ROUTES.ORGANIZER_PUBLIC_PROFILE,params:{organizerId:  data.creator._id, profileType:'personal'}}).then(() => {
//       location.href = window.location.href; // Force reload by updating the URL
//     });

//   }else if(!data.role && data.creator.organization){
//     if(data.creator.role == 'Seeker'){
      
//       router.push({name:ROUTES.ORGANIZER_PUBLIC_PROFILE,params:{organizerId:  data.creator._id, profileType:'personal'}}).then(() => {
//         location.href = window.location.href; // Force reload by updating the URL
//       });

//     }else{
//       router.push({name:ROUTES.ORGANIZER_PUBLIC_PROFILE,params:{organizerId:  data.creator._id, profileType:'bussiness'}}).then(() => {
//         location.href = window.location.href; // Force reload by updating the URL
//       });
//     }
    
//   }
// }

//  const favouriteEvent = (id) => {
//   alert(id)
//   return false;
//   if (!isFavouriteLoading.value && !isUnFavouriteLoading.value) {
//     if (isFollowOrFav.value?.isEventFavourite) {
//       removeEventFromFavourite(id);
//     } else {
//       addEventToFavourite(id);
//     }
//   }
// };

// const detail=(id)=>{
//   if(props.isEdit){
//     router.push({path:`/add-events/${id}`})
//   }else{
//     router.push({name:ROUTES.EVENT,params:{eventId:id}})
//   }

const handleGoToPublicProfile = (event) => {
  event.stopPropagation();
  const data = normalizedEventData.value;

  let organizerId = null;
  let profileType = 'business';

  const getOrganizerId = (...candidates) => candidates.find(id => id);

  if (data?.role === 'Organization') {
    organizerId = getOrganizerId(
      data.creator?.organization && data.creator._id,
      data.createdBy?.organization && data.createdBy._id,
      !data.creator?.organization && !data.createdBy?.organization && props.creatorData?._id
    );
  } else if (data?.role === 'Organizer') {
    profileType = 'personal';
    organizerId = getOrganizerId(
      data.createdBy?.organizerDetails?.firstName && data.createdBy._id,
      props.creatorData?._id,
      data.creator?._id
    );
  } else if (!data?.role && data.creator?.organization) {
    profileType = data.creator.role === 'Seeker' ? 'personal' : 'business';
    organizerId = data.creator._id;
  }

  if (organizerId) {
    router.push({
      name: ROUTES.ORGANIZER_PUBLIC_PROFILE,
      params: { organizerId, profileType }
    });
  }
};


const detail = (title,id) => {
  // router.push({ name: ROUTES.EVENT, params: { eventTitle:createSeoFriendlyUrl(title) } })
  location.href='/event/'+createSeoFriendlyUrl(title)
}


const viewProfile = (role,id) => {
  if(role == 'Seeker'){
    router.push({ name: ROUTES.ORGANIZER_PUBLIC_PROFILE, params: { organizerId: id ? id : 0,profileType:'personal' } })
  }else{
    router.push({ name: ROUTES.ORGANIZER_PUBLIC_PROFILE, params: { organizerId: id ? id : 0,profileType:'business' } })
  }

}

// if(user){
//   router.push({name:ROUTES.EVENT,params:{eventId:id}})
// }else{
//   let el=document.getElementById("loginBtn")
//   if(el) el.click()
// }


const eventImg = (img) => {
  return getEventImageUrl(img)
}
// const userImg = (img) => {
//   console.log(img, "img");
//   let value = `${MEDIA_BASEURL}${img}`
//   // if (img == 'nouser.png') { value = '/nouser.png' } 
//   if (img == 'placeholder.png') { value = '/placeholder.png' } 
//   if (img && img.includes('https')) value = img
//   return value
// }

const userImg = (role, img) => {
  let value = `${MEDIA_BASEURL}${img}`
  // if (img == 'nouser.png') { value = '/nouser.png' } 
  // if(userProfile.role == ''){

  // }
  if(role == 'Organizer'){
    if (img == undefined) { value = '/placeholder_org.png' }
    if (img == 'placeholder.png') { value = '/placeholder_org.png' }
    if (img == 'placeholder_org.png') { value = '/placeholder_org.png' } 
    if (img == '') { value = '/placeholder_org.png' } 
    if (img && img.includes('https')) value = img
  }else{
    if (img == undefined) { value = '/placeholder.png' }
    if (img == 'placeholder.png') { value = '/placeholder.png' }
    if (img == '') { value = '/placeholder.png' }
    if (img == 'placeholder_org.png') { value = '/placeholder.png' } 
    if (img && img.includes('https')) value = img
  }
  
  return value
}

const showResponseMessage = (successMsg,errorMsg) =>{
  if(successMsg != ''){

    errorMessage.value = '';
    successMessage.value = successMsg
  }else if(errorMsg != ''){
    errorMessage.value = errorMsg;
    successMessage.value = '';
  }else{
  }
    setTimeout(() => {
      errorMessage.value = '';
      successMessage.value = '';

    }, 1000);
}

const copyUrlToClipboard = async (event, eventTitle) => {
  // Prevent event bubbling to parent elements
  event.stopPropagation();
  
  const url = BASE_URL + 'event/' + createSeoFriendlyUrl(eventTitle);
  
  try {
    await navigator.clipboard.writeText(url);
    showResponseMessage('Copied!', '');
  } catch (error) {
    console.error('Failed to copy URL to clipboard:', error);
    showResponseMessage('Failed to copy URL', 'error');
  }
};

const shareOnFacebook = (event,eventTitle, eventStartDateTime, eventTimeZone) => {
  // Prevent card click redirect
  event.stopPropagation();
  const eventStartDate = `${new Date(eventStartDateTime)
    .toLocaleString("en-US", { timeZone: eventTimeZone })
    .split(",")[0]?.trim() || "-"}`;
  const eventStartTime = dateModel.time(eventStartDateTime, eventTimeZone);
  const text = encodeURIComponent(`Please join me at ${eventTitle} on ${eventStartDate} ${eventStartTime}. Click below for more details`);
  const url = encodeURIComponent(BASE_URL + 'event/' + createSeoFriendlyUrl(eventTitle));
  window.open(`https://www.facebook.com/sharer/sharer.php?t=${text}&u=${url}`, '_blank');
};

const shareOnTwitter = (event,eventTitle, eventStartDateTime, eventTimeZone) => {
  // Prevent card click redirect
  event.stopPropagation();
  const eventStartDate = `${new Date(eventStartDateTime)
    .toLocaleString("en-US", { timeZone: eventTimeZone })
    .split(",")[0]?.trim() || "-"}`;
  const eventStartTime = dateModel.time(eventStartDateTime, eventTimeZone);
  const text = encodeURIComponent(`Please join me at ${eventTitle} on ${eventStartDate} ${eventStartTime}. Click below for more details`);
  const url = encodeURIComponent(BASE_URL + 'event/' + createSeoFriendlyUrl(eventTitle));
  window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank');
};

const shareOnLinkedIn = (event,eventTitle, eventStartDateTime, eventTimeZone) => {
  // Prevent card click redirect
  event.stopPropagation();
  const eventStartDate = `${new Date(eventStartDateTime)
    .toLocaleString("en-US", { timeZone: eventTimeZone })
    .split(",")[0]?.trim() || "-"}`;
  const eventStartTime = dateModel.time(eventStartDateTime, eventTimeZone);
  const url = BASE_URL + 'event/' + createSeoFriendlyUrl(eventTitle);
  const text = encodeURIComponent(`Please join me at ${eventTitle} on ${eventStartDate} ${eventStartTime}. Click below for more details\n${url}`);
  window.open(`https://www.linkedin.com/feed/?shareActive=true&text=${text}`, '_blank');
};

const shareOnWhatsApp = (event,eventTitle, eventStartDateTime, eventTimeZone) => {
  // Prevent card click redirect
  event.stopPropagation();
  const eventStartDate = `${new Date(eventStartDateTime)
    .toLocaleString("en-US", { timeZone: eventTimeZone })
    .split(",")[0]?.trim() || "-"}`;
  const eventStartTime = dateModel.time(eventStartDateTime, eventTimeZone);
  const text = encodeURIComponent(`Please join me at ${eventTitle} on ${eventStartDate} ${eventStartTime}. Click below for more details:`);
  const url = encodeURIComponent(BASE_URL + 'event/' + createSeoFriendlyUrl(eventTitle));
  window.open(`https://api.whatsapp.com/send?text=${text}%0A${url}`, '_blank');
};

const eventFullUrl = (title) =>{
  if(!title) return '';

  const url = BASE_URL+'event/'+title;

  return url;
}

</script>
<style scoped>
.decription {
  margin-bottom: 30px;
}
section.carousel.custom-carousel li.carousel__slide article.info-box {
    width: 100%;
    min-height: 100%;
}

section.carousel.custom-carousel li.carousel__slide article.info-box img {
    left: 0;
}
.info-box-content-s , .info-box-content .info-box-title{
  text-align: left;
}
span.info-box-content.info-box-content-footer hr {
    border-color: #333;
}
span.info-box-content.info-box-content-footer {
    margin-top: auto;
}
  .related-event-section article.info-box {
  width: 90%;
  min-height: 100%;
}
.related-event-section article.info-box .info-box-img img {
    left: 0;
}

.copy-btn-hover{
  color: white;
}

.copy-btn-hover:hover {
border-color: orangered;
color:orangered
}

.toast-success {
  color: darkgreen;
  font-size: 1.05rem;
}

.toast-error {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #ef4444;
}

.successMessage {
  padding: 1px;
}

.share-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.share-popup {
  background: white;
  padding: 30px;
  border-radius: 9px;
  max-width: 500px;
  height:225px
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popup-icons {
  margin-top: 10px;
  display: flex;
  gap: 22px;
  justify-content: center;
}
.close-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
  margin-left: 400px;
}
.pop-heading {
  font-size: 16px;
}
.copy-input {
  margin-right:20px;
  margin-top: 10px;
  border-color: #000 !important;
}
.copy-input input {
  flex: 1; /* input takes full available width */
}
.copy-input input:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #000 !important;
}


@media (max-width: 580px) {
  .share-popup {
    margin: 0 15px
  }
  .copy-input {
    margin-right:0px;
    margin-bottom: 20px;
  }
  .close-btn {
    margin-left: 10px;
  }

}
.popup-section-title {
  font-size: 16px;
  font-weight: 600;
  margin: 15px 0 8px; /* spacing top and bottom */
}
</style>